/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
 */

import React from 'react'
import R from 'ramda'
import moment from 'moment'
import autoBind from 'react-autobind'
import { withRouter } from 'react-router-dom'
import { injectIntl } from 'react-intl'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { ListItem as MaterialListItem, CircularProgress, RaisedButton } from 'material-ui'
import { ListItem } from 'generic/list'

import * as headerConstants from 'constants/Header'
import * as headerActions from 'actions/Header'
import * as actions from 'actions/ApplicantPrestation'
import { docSaver } from 'utils/file'

import * as constants from 'constants/Prestation'
import * as loginConstants from 'constants/Login'

class ActionPanel extends React.Component {
  constructor (props) {
    super(props)

    autoBind(this)

    this.state = {
      loadingDeliveryNoteAction: false,
      loadingDocumentAction: false,
      loadingResentAction: false,
    }

    this.resentActionInFlight = false
  }

  isPrestationWorkflowActionAvailable (actionName) {
    const actions = R.path(['workflow_objects', 0, 'operations'], this.props.prestation)

    return actions.filter((action) => {return action.name === actionName})[0] &&
           this.props.user.role !== loginConstants.PAYING_CUSTOMER_ROLE
  }

  isModificationAvailable () {
    if (this.props.user.updatePaidPrestation) {
      return true
    }

    const step = R.path(['workflow_objects', 0, 'step_name'], this.props.prestation)

    let condition = step === constants.INVITATION_SENT_PRESTATION_STATUS ||
                    step === constants.INVITATION_RESENT_PRESTATION_STATUS ||
                    step === constants.ACCEPTED_PRESTATION_STATUS ||
                    step === constants.CONFIRMED_PRESTATION_STATUS ||
                    step === constants.TO_VALIDATE_PRESTATION_STATUS ||
                    step === constants.VALIDATED_PRESTATION_STATUS ||
                    step === constants.CANCELLED_PRESTATION_STATUS

    if (this.props.user.is_staff) {
      return condition || step === constants.PAID_PRESTATION_STATUS
    } else if (this.props.user.role === loginConstants.APPLICANT_ROLE) {
      return condition
    }

    return false
  }

  isCancelAvailable () {
    return this.isPrestationWorkflowActionAvailable(constants.CANCELLED_PRESTATION_STATUS) &&
    (this.props.user.is_staff || !R.path(['invoice_only_additional_services'], this.props.prestation))
  }

  isProposalAvailable () {
    const prestationStep = R.path(['workflow_objects', 0, 'step_name'], this.props.prestation)

    return (prestationStep === constants.ACCEPTED_PRESTATION_STATUS ||
            prestationStep === constants.CONFIRMED_PRESTATION_STATUS) &&
            this.props.user.role === loginConstants.APPLICANT_ROLE &&
            !this.props.prestation.invoice_only_additional_services
  }

  isDuplicateAvailable () {
    return (
      this.props.user.role === loginConstants.APPLICANT_ROLE && 
      this.props.user.newPrestationAccess
    )
  }

  isPhotoReminderAvailable () {
    const prestationStep = R.path(['workflow_objects', 0, 'step_name'], this.props.prestation)

    return this.props.user.is_staff &&
           (prestationStep === constants.VALIDATED_PRESTATION_STATUS ||
            prestationStep === constants.PAID_PRESTATION_STATUS ||
            prestationStep === constants.INVOICED_PRESTATION_STATUS ||
            prestationStep === constants.TO_VERIFY_PRESTATION_STATUS ||
            prestationStep === constants.CLOSED_PRESTATION_STATUS)
  }

  isDeliveryNoteAvailable () {
    const prestationStep = R.path(['workflow_objects', 0, 'step_name'], this.props.prestation)

    return (prestationStep === constants.TO_VALIDATE_PRESTATION_STATUS ||
            prestationStep === constants.VALIDATED_PRESTATION_STATUS ||
            prestationStep === constants.PAID_PRESTATION_STATUS ||
            prestationStep === constants.INVOICED_PRESTATION_STATUS ||
            prestationStep === constants.TO_VERIFY_PRESTATION_STATUS ||
            prestationStep === constants.CLOSED_PRESTATION_STATUS) & (
              this.props.user.is_staff ||
              this.props.user.role === loginConstants.PAYING_CUSTOMER_ROLE
            )
  }

  isAudioVideoAvailable () {
    const prestationStep = R.path(['workflow_objects', 0, 'step_name'], this.props.prestation)

    return this.props.user.role === loginConstants.APPLICANT_ROLE && (
      prestationStep === constants.ACCEPTED_PRESTATION_STATUS ||
      prestationStep === constants.CONFIRMED_PRESTATION_STATUS ||
      prestationStep === constants.TO_VALIDATE_PRESTATION_STATUS
    )
      
  }

  isResentAvailable () {
    const prestationStep = R.path(['workflow_objects', 0, 'step_name'], this.props.prestation)

    const steps = this.props.histories.filter(obj => obj.step_name === constants.CANCELLED_PRESTATION_STATUS) || []
    if (!steps.length) {
      return false
    } 

    const user = steps.at(-1).user

    return this.props.user.is_staff &&
           moment(this.props.prestation.ordered_start_time).isAfter(moment()) &&
           prestationStep === constants.CANCELLED_PRESTATION_STATUS &&
           (user.roles[0].role === loginConstants.INTERPRETER_ROLE ||
            user.is_staff === true)
  }

  handleEditPrestation () {
    const prestationUid = this.props.prestation.uid
    this.props.history.push({pathname: '/prestation/' + prestationUid + '/'})
    this.props.headerActions.selectPage(1)
  }

  handleDeliveryNote () {
    this.setState({
      loadingDeliveryNoteAction: true
    })

    actions.exportDeliveryNote(this.props.prestation)
      .then((res) => {
        const file = docSaver(res.data.document)
        var url = URL.createObjectURL(file)
        window.open(url,'_blank')
      })
      .catch((e) => {
        this.setState({
          error: e,
        })
      })
      .finally(() => {
        this.setState({
          loadingDeliveryNoteAction: false
        })
      })      
  }

  handleSendReminderPrestation () {
    this.setState({
      loadingDocumentAction: true
    })

    const data = {
      name: 'prestation_workflow',
      operation_name: 'send_interpreter_document_reminder'
    }

    this.props.actions.executeAction(
        data, 
        this.props.prestation,
        this.props.intl
    )
      .finally(() => {
        this.setState({
          loadingDocumentAction: false
        })
      })
  }

  handleDuplicatePrestation () {
    this.props.history.push({
      pathname: '/prestation/',
      params: {duplicate: true, uid: this.props.prestation.uid}
    })
    this.props.headerActions.selectPage(1)
  }

  handleResentPrestation () {
    if (this.resentActionInFlight || this.state.loadingResentAction) {
      return
    }

    this.resentActionInFlight = true

    this.setState({
      loadingResentAction: true
    })

    const data = {
      name: "prestation_workflow",
      operation_name: "invitation_resent"
    }

    this.props.actions.executeAction(
        data, 
        this.props.prestation,
        this.props.intl
    )
    .then(() => {
      return actions.getPrestationUid(this.props.prestation.uid)
    })
    .then((result) => {
      this.props.handleUpdatedPrestation(result.data.object)
      this.props.actions.selectPrestation(result.data.object)
    })
    .finally(() => {
      this.setState({
        loadingResentAction: false
      })
      this.resentActionInFlight = false
    })
  }

  render () {
    if (!this.isModificationAvailable() &&
        !this.isCancelAvailable() &&
        !this.isProposalAvailable() &&
        !this.isDuplicateAvailable() &&
        !this.isPhotoReminderAvailable() &&
        !this.isDeliveryNoteAvailable() &&
        !this.isAudioVideoAvailable()) {
      return (<React.Fragment></React.Fragment>)
    }

    if (R.path(['is_archived'], this.props.prestation)) {
      return (<React.Fragment></React.Fragment>)
    }

    return (
      <MaterialListItem
        primaryText={this.props.intl.formatMessage(constants.messages.PRESTATION_ACTIONS_LABEL)}
        initiallyOpen={true}
        primaryTogglesNestedList={true}
        nestedListStyle={{padding: 0}}
        nestedItems={[
          <ListItem
            disabled
            key={0}
            style={{margin: 0}}
            nestedListStyle={{padding: 0}}
            primaryText={
              <div className='row'>
                {
                  this.isModificationAvailable()
                    ? <RaisedButton
                      style={{margin: '1%', minWidth: 0, width: '45%', textOverflow: 'ellipsis'}}
                      labelStyle={{fontSize: 12, padding: 0}}
                      primary={true}
                      label={this.props.intl.formatMessage(constants.messages.EDIT_ACTION_LABEL)}
                      onClick={this.handleEditPrestation}
                    />
                    : undefined
                }

                {
                  this.isCancelAvailable()
                    ? <RaisedButton
                      style={{margin: '1%', minWidth: 0, width: '45%', textOverflow: 'ellipsis'}}
                      labelStyle={{fontSize: 12, padding: 0}}
                      primary={true}
                      label={this.props.intl.formatMessage(constants.messages.CANCEL_ACTION_LABEL)}
                      onClick={this.props.cancelPrestation}
                    />
                    : undefined
                }

                {
                  this.isProposalAvailable()
                    ? <RaisedButton
                      style={{margin: '1%', minWidth: 0, width: '45%', textOverflow: 'ellipsis'}}
                      labelStyle={{fontSize: 12, padding: 0}}
                      primary={true}
                      label={this.props.intl.formatMessage(constants.messages.PROPOSAL_ACTION_LABEL)}
                      onClick={this.props.handleProposal}
                      disabled={this.props.disableProposal}
                    />
                    : undefined
                }

                {
                  this.isDuplicateAvailable()
                    ? <RaisedButton
                      style={{margin: '1%', minWidth: 0, width: '45%', textOverflow: 'ellipsis'}}
                      labelStyle={{fontSize: 12, padding: 0}}
                      primary={true}
                      label={this.props.intl.formatMessage(constants.messages.DUPLICATE_ACTION_LABEL)}
                      onClick={this.handleDuplicatePrestation}
                    />
                    : undefined
                }

                {
                  this.isPhotoReminderAvailable()
                    ? <RaisedButton
                      style={{margin: '1%', minWidth: 0, width: '45%', textOverflow: 'ellipsis'}}
                      labelStyle={{fontSize: 12, padding: 0}}
                      primary={true}
                      disabled={this.state.loadingDocumentAction}
                      label={
                        this.state.loadingDocumentAction
                          ? <CircularProgress
                            className='inline center'
                            size={20}
                            style={{paddingTop: 5}}
                          />
                          : this.props.intl.formatMessage(constants.messages.REMINDER_PHOTO_ACTION_LABEL)
                      }
                      onClick={this.handleSendReminderPrestation}
                    />
                    : undefined
                }

                {
                  this.isDeliveryNoteAvailable()
                    ? <RaisedButton
                      style={{margin: '1%', minWidth: 0, width: '45%', textOverflow: 'ellipsis'}}
                      labelStyle={{fontSize: 12, padding: 0}}
                      primary={true}
                      disabled={this.state.loadingDeliveryNoteAction}
                      label={
                        this.state.loadingDeliveryNoteAction
                          ? <CircularProgress
                            className='inline center'
                            size={20}
                            style={{paddingTop: 5}}
                          />
                          : this.props.intl.formatMessage(constants.messages.DELIVERY_NOTE_ACTION)
                      }
                      onClick={this.handleDeliveryNote}
                    />
                    : undefined
                }

                {
                  this.isAudioVideoAvailable()
                    ? <RaisedButton
                      style={{margin: '1%', minWidth: 0, width: '45%', textOverflow: 'ellipsis'}}
                      labelStyle={{fontSize: 12, padding: 0}}
                      primary={true}
                      href={constants.AUDIO_VIDEO_URL + this.props.prestation.id}
                      target='_blank'
                      label="Appel audio / vidéo"
                    />
                    : undefined
                }

                {
                  this.isResentAvailable()
                    ? <RaisedButton
                      style={{margin: '1%', minWidth: 0, width: '45%', textOverflow: 'ellipsis'}}
                      labelStyle={{fontSize: 12, padding: 0}}
                      disabled={this.state.loadingResentAction}
                      primary={true}
                      label={this.props.intl.formatMessage(constants.messages.RESENT_LABEL)}
                      onClick={this.handleResentPrestation}
                    />
                    : undefined
                }
              </div>
            }
          />
        ]}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  user: state.User.user,
})

const mapActionsToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch),
  headerActions: bindActionCreators(headerActions, dispatch)
})

export default withRouter(
  connect(mapStateToProps, mapActionsToProps)
  (injectIntl(ActionPanel))
)



// WEBPACK FOOTER //
// ./src/components/applicant/prestation/dashboard/ActionPanel.js